export function productCategoryKey(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLocaleLowerCase('pt-BR')
    .replace(/\s+/g, ' ')
}

export function productCategoriesMatch(left: string, right: string): boolean {
  return productCategoryKey(left) === productCategoryKey(right)
}

const localizedCategoryLabels: Record<string, string> = {
  educacao: 'Educação',
  negocios: 'Negócios',
  'saude e bem-estar': 'Saúde e bem-estar',
  financas: 'Finanças',
}

export function productCategoryLabel(value: string): string {
  return localizedCategoryLabels[productCategoryKey(value)] ?? value
}
